"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var BlendButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/BlendButton"));
var Modal_1 = __importDefault(require("atomicComponents/organisms/Modal"));
var ModalContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalContent"));
var ModalFooter_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalFooter"));
var ModalHeader_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalHeader"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var VendorEmailContent_1 = __importDefault(require("./VendorEmailContent"));
var VendorEmailModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, setStep = _a.setStep, _b = _a.vendor, vendor = _b === void 0 ? 'Xero' : _b, props = __rest(_a, ["open", "onClose", "setStep", "vendor"]);
    var _c = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany), emailStatus = _c.firstInvoiceEmailStatus, companyName = _c.name, companyId = _c.id;
    var _d = __read((0, hooks_1.useSubmitter)('recharger_companies', companyId), 2), submit = _d[0], loading = _d[1];
    return ((0, jsx_runtime_1.jsxs)(Modal_1.default, __assign({ open: open, onClose: onClose }, props, { label: "".concat(vendor, " Email"), PaperProps: { sx: { maxWidth: 720 } } }, { children: [(0, jsx_runtime_1.jsx)(ModalHeader_1.default, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Forward Email" })) }), (0, jsx_runtime_1.jsx)(ModalContent_1.default, { children: (0, jsx_runtime_1.jsx)(VendorEmailContent_1.default, { vendor: vendor, companyName: companyName !== null && companyName !== void 0 ? companyName : 'COMPANY_NAME' }) }), (0, jsx_runtime_1.jsx)(ModalFooter_1.default, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ direction: "row", alignItems: "center", justifyContent: "flex-end", spacing: 3 }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ color: "neutral", size: "large", onClick: onClose }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(BlendButton_1.default, __assign({ onClick: function () { return submit({ firstInvoiceEmailStatus: emailStatus !== 'processed' ? 'pendingReception' : undefined })
                                .then(onClose); }, isSending: loading, size: "large" }, { children: "I\u2019ve done this!" }))] })) })] })));
};
exports.default = VendorEmailModal;
